// BranchCard.jsx
import React from "react";
import { motion } from "framer-motion";
import { FiMapPin, FiPhone, FiExternalLink } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const cardVariants = {
  offscreen: { y: 50, opacity: 0 },
  onscreen: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", bounce: 0.4, duration: 0.8 }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

const BranchCard = ({ branch }) => {
  const { t } = useTranslation();

  const openGoogleMaps = () => {
    window.open(branch?.location, "_blank");
  };

  return (
    <Link to={"/show/info/branch/" + branch.id}>
      <motion.div
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true, amount: 0.2 }}
        variants={cardVariants}
        whileHover={{ y: -5, transition: { type: "spring", stiffness: 300 } }}
        className="group bg-white cursor-pointer rounded-md  hover:shadow-[#15803d]/20  shadow-md hover:shadow-2xl transition-shadow duration-300 w-full max-w-[400px] h-full flex flex-col"
      >
        <div className="relative overflow-hidden flex-shrink-0">
          <img
            src={process.env.REACT_APP_IMG_URL + branch.image}
            alt={branch.name}
            className="w-full rounded-md h-64 object-cover"
          />
          <motion.div
            onClick={openGoogleMaps}
            whileTap={{ scale: 0.95 }}
            className="absolute top-4 right-4 bg-gradient-to-r from-[#15803d] to-[#15803d]/80 text-white px-4 py-2 rounded-full text-sm font-semibold cursor-pointer flex items-center gap-2 backdrop-blur-sm bg-opacity-90 hover:bg-opacity-100 transition-all"
          >
            {t("viewOnMap")}
            <FiExternalLink className="w-4 h-4" />
          </motion.div>
        </div>

        <div className="p-6 flex-1 flex flex-col">
          <h3 className="text-2xl font-bold  bg-clip-text text-clip text-transparent bg-gradient-to-tr from-[#15803d] to-[#15803d]/90 tracking-wide">
            {branch.name}
          </h3>

          <motion.div
            className="space-y-3 mt-4 flex-1"
            initial="hidden"
            animate="visible"
            variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
          >
            <motion.div variants={itemVariants} className="flex items-start">
              <FiMapPin className="w-6 h-6 mr-3 mt-1 flex-shrink-0 text-blue-600" />
              <span className="text-gray-700">{branch.address}</span>
            </motion.div>

            <div className="flex gap-4 items-center justify-between">
              <motion.div variants={itemVariants} className="flex items-center gap-3">
                <FiPhone className="w-6 h-6 mr-3 flex-shrink-0 text-green-600" />
                <a
                  href={`tel:${branch.phone}`}
                  className="font-medium hover:underline hover:text-blue-700"
                >
                  {branch.phone}
                </a>
              </motion.div>
              {
                branch?.second_phone && <motion.div variants={itemVariants} className="flex items-center gap-3">
                  <FiPhone className="w-6 h-6 mr-3 flex-shrink-0 text-green-600" />
                  <a
                    href={`tel:${branch.second_phone}`}
                    className="font-medium hover:underline hover:text-blue-700"
                  >
                    {branch.second_phone}
                  </a>
                </motion.div>
              }

            </div>
          </motion.div>

          {branch.description && (
            <p className="mt-4 text-gray-600 text-sm border-t pt-4 border-gray-100">
              {branch.description}
            </p>
          )}
        </div>

        {/* <div className="absolute inset-0 rounded-3xl border-2 border-transparent group-hover:border-blue-200 transition-all duration-300 pointer-events-none" /> */}
      </motion.div>
    </Link>
  );
};

export default BranchCard;